/* eslint-disable react/no-danger */
import React, { useState, useEffect } from "react";
import { Section } from "../../sharedComponents/Section/Section";
import { AlertConnector as Alert } from "../Alert";
import { useUser } from "../../context";
import { RCL } from "../RCL";
import * as styles from "./Header.module.scss";

const AffiliateAlert = () => {
	const { affiliate, user } = useUser();
	const [affiliateMessage, setAffiliateMessage] = useState(null);

	const dictionary = {
		"membership-welcome": RCL({ searchKey: "okta-profile-membership-welcome" }),
	};

	const [showAffiliateAlert, setShowAffiliateAlert] = useState(false);

	useEffect(() => {
		// Check for affiliate program alert state
		if (
			sessionStorage?.getItem("_apa") !== "false" &&
			user?.profile?.firstName &&
			affiliate?.name
		) {
			const message = dictionary["membership-welcome"]
				.replace("{fname}", user.profile.firstName)
				.replace("{pname}", `<strong>${affiliate.name}</strong>`);
			setAffiliateMessage(message);
			setShowAffiliateAlert(true);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [affiliate, user]);

	if (showAffiliateAlert) {
		return (
			<Section padding="none">
				<Alert
					variant="none"
					className={styles.headerAffiliateAlert}
					classNames={{
						wrapper: styles.headerAlertWrapper,
						body: styles.headerAlertBody,
						headingContainer: styles.headerAlertContainer,
					}}
					onClick={() => {
						sessionStorage.setItem("_apa", false);
					}}>
					<div dangerouslySetInnerHTML={{ __html: affiliateMessage }} />
				</Alert>
			</Section>
		);
	}
	return null;
};
export default AffiliateAlert;
export { AffiliateAlert };
